export const trackingEvents = {
  SAVE_BUTTON: {
    CLICKED: 'agency_profile.save_button.clicked',
  },
  DELETE_EMPLOYER_BUTTON: {
    CLICKED: 'agency_profile.delete_employer_button.clicked',
  },
}
